// @flow

import merge from 'lodash/merge';
import type { reduxAction } from '../dataStoreTypes';

const initialState = {
  user: {},
  profile: {},
  categorySummary: {},
  notifications: {},
  lands: {},
  chatUsers: {},
  chats: {},
  paymentMethods: {},
  images: {},
  offerings: {},
  video: {},
  purchases: {},
  categories: {},
  reviews: {},
  coupons: {},
  bookmarks: {},
};

type State = {
  user: {},
  profile: {},
  categorySummary: {},
  notifications: {},
  lands: {},
  chatUsers: {},
  chats: {},
  paymentMethods: {},
  images: {},
  offerings: {},
  video: {},
  purchases: {},
  categories: {},
  reviews: {},
  coupons: {},
  bookmarks: {},
};

const updateEntity = (state, action) => {
  const newState = state;
  newState[action.entityToUpdate][action.entity.id] = action.entity;
  return newState;
};

export default function entities(
  state: State = initialState,
  action: reduxAction,
): State {
  if (action.entities) {
    return merge({}, state, action.entities);
  }

  switch (action.type) {
    case 'UpdateEntities':
      return updateEntity(state, action);
    default:
      return state || {};
  }
}
